import React, { useState, useEffect } from "react";
import Modal from "../../../assets/components/ModalComonent";
import classes from "../styles/style.module.css";
import CustomInput from "../../../assets/components/customInput";
import CustomButton from "../../../assets/components/CustomButton";

const SubmitCountModal = ({ show, closeHandler, handleConfirm, data }) => {
  const [inputData, setInputData] = useState("");
  const setInputFocus = (inputElement) => {
    if (inputElement && show) {
      setTimeout(() => inputElement.focus(), 0);
    }
  };

  useEffect(() => {
    if (!show) {
      setInputData("");
    }
  }, [show]);

  const content = (
    <div className={classes.submitCountContent}>
      <h5 className="text-center">تعداد نفرات</h5>
      <CustomInput
        name={"personCountInput"}
        value={inputData}
        handleChange={(value) => setInputData(value)}
        placeholder={"تعداد نفرات"}
        reference={setInputFocus}
      />
      <p className="text-right">{`حداکثر : ${data?.maxParticipantPerFamily || ""}`}</p>

      <div className="mt-3 d-flex justify-content-between align-items-center">
        <CustomButton
          shadow={true}
          color={"primary"}
          clickHandler={() => handleConfirm(inputData)}
          text={"تایید"}
          styles={{ width: "40%" }}
        />
        <CustomButton
          shadow={true}
          color={"secondary"}
          clickHandler={closeHandler}
          text={"لغو"}
          styles={{ width: "43%" }}
        />
      </div>
    </div>
  );
  return (
    <Modal
      open={show}
      closeHandler={closeHandler}
      dialogContent={content}
      inputDialog={true}
    />
  );
};

export default SubmitCountModal;
